<template>
  <section class="regional">
    <div class="layout system-setting-layout" style="z-index: 11;">
      <div class="system-setting">
        <div class="layout-header regional-header" ref="searchBox">
          <div class="infor-layout-header">
            <span class="title">区域设置</span>
            <p>
              <el-button v-show="checkUserAuth(6, 100)" type="primary" size="small" @click="onAdd('添加区域', 'formAdd')">添加区域</el-button>
              <el-button size="small" @click="onMerge('合并成复合区', 'mergeArea')">勾选合并</el-button>
              <!-- <el-button size="small" @click="onClickDel">删除</el-button> -->
            </p>
          </div>
        </div>
        <div style="height:80px;"></div>
        <div class="regional_table">
          <el-table
            v-show="checkUserAuth(6, 99)"
            v-loading.body="tableLoading"
            class="table_content"
            :max-height="tableViewHeight"
            :data="tableData"
            style="width: 100%;margin-bottom: 20px;"
            row-key="id"
            :tree-props="{children: 'child', hasChildren: 'hasChildren'}"
            :header-cell-class-name="cellClass"
            @selection-change="onSelectionChange"
            @row-click="onRowClick">
            <el-table-column
              :selectable="selectable"
              type="selection"
              width="55">
            </el-table-column>
            <el-table-column
              prop="areaName"
              label="区域名称"
              width="250">
            </el-table-column>
            <el-table-column
              prop="level"
              label="区域等级"
              width="250">
              <template slot-scope="props">
                <span>{{getLevel(props.row.level)}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="id"
              label="区域代码">
            </el-table-column>
            <el-table-column
              prop="platformCode"
              label="站点代码">
            </el-table-column>
            <el-table-column
              label="监管平台是否显示">
              <template slot-scope="props">
                <!-- <template v-if="props.row.level>=2">
                  <el-switch v-model="props.row.monitorOpen" @change="onSwitchChange(props.row)"></el-switch>
                </template> -->
                <el-switch v-model="props.row.monitorOpen" @change="onSwitchChange(props.row)"></el-switch>
              </template>
            </el-table-column>
            <el-table-column
              label="觅单车是否显示">
              <template slot-scope="props">
                <!-- <template v-if="props.row.level>=2">
                  <el-switch v-model="props.row.monitorOpen" @change="onSwitchChange(props.row)"></el-switch>
                </template> -->
                <el-switch :disabled="!props.row.monitorOpen" v-model="props.row.isOpen" @change="onSwitchChangeMi(props.row)"></el-switch>
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              width="100">
              <template slot-scope="scope">
                <div v-if="scope.row.level>=2" class="right el-button-box">
                  <!-- 实体区进行控制 -->
                  <el-button style="padding:0;" v-show="checkUserAuth(6, 103)" v-if="scope.row.aggregation === 0" class="btn-text" @click="onClick(scope.row, 'painting')" type="text" size="small">围栏绘制</el-button>
                  <el-button style="padding:0;" v-show="checkUserAuth(6, 105)" v-if="scope.row.aggregation === 0" class="btn-text" @click="onClick(scope.row, 'paintingEdit')" type="text" size="small">修改围栏</el-button>
                  <el-button style="padding:0;" v-show="checkUserAuth(6, 101)" v-if="scope.row.aggregation === 0" class="btn-text" @click="onEdit('edit', scope.row)" type="text" size="small">修改区域</el-button>
                  <el-button style="padding:0;" v-show="checkUserAuth(6, 102)" v-if="scope.row.aggregation === 0" class="btn-text" @click="onDel('del', scope.row)" type="text" size="small">删除区域</el-button>

                  <!-- <el-button style="padding:0;" v-show="checkUserAuth(6, 103)"  class="btn-text" @click="onClick(scope.row, 'painting')" type="text" size="small">围栏绘制</el-button>
                  <el-button style="padding:0;" v-show="checkUserAuth(6, 105)"  class="btn-text" @click="onClick(scope.row, 'paintingEdit')" type="text" size="small">修改围栏</el-button>
                  <el-button style="padding:0;" v-show="checkUserAuth(6, 101)"  class="btn-text" @click="onEdit('edit', scope.row)" type="text" size="small">修改区域</el-button>
                  <el-button style="padding:0;" v-show="checkUserAuth(6, 102)"  class="btn-text" @click="onDel('del', scope.row)" type="text" size="small">删除区域</el-button> -->
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div v-show="!checkUserAuth(6, 99)">您的账户没有权限查看此内容！</div>
        </div>
      </div>
    </div>
    <!-- 一级弹窗 -->
    <w-dialog
      width="50%"
      ref="w-dialog"
      :title="dialogTitle"
      :sureBtnText="sureBtnText"
      @handleCloseRight="onRightClose"
      @handleClose="onClose"
      @onSure="onSure">
      <template v-slot:content>
        <div v-if="['formAdd', 'edit'].includes(type)">
          <el-form ref="formAdd" :rules="formAddRules" :model="formAdd" label-width="80px">
            <template v-if="type === 'formAdd'">
              <el-form-item label="选择省份" prop="level">
                <el-cascader
                size="small"
                class="w250"
                :props="addressCascader"
                v-model="formAdd.level"
                :options="nationAddress"
                @change="onAddressChange"></el-cascader>
              </el-form-item>
            </template>
            <el-form-item label="区域名称" prop="areaName">
              <el-input size="small" v-model="formAdd.areaName" placeholder="请输入区域名称" class="w250"></el-input>
            </el-form-item>
            <el-form-item label="区域代码" prop="id">
              <template v-if="type === 'formAdd'">
                <span class="nums" v-if="formAdd.level && formAdd.level.length">{{formAdd.level[formAdd.level.length - 1].slice(0, 4)}}</span>
              </template>
              <template v-if="type === 'edit'">
                <span class="nums" v-if="editData.id">{{editData.id.slice(0, 4)}}</span>
              </template>
              <el-input size="small" :disabled="type === 'edit'" v-model="formAdd.id" placeholder="请输入区域代码" class="w250 el-input-45"></el-input>
              <span class="tips">6位数字</span>
            </el-form-item>
            <el-form-item label="站点代码" prop="platformCode">
              <template v-if="type === 'formAdd'">
                <span class="nums" v-if="currItem && currItem.platformCode">{{currItem.platformCode.slice(0, 6)}}</span>
              </template>
              <template v-if="type === 'edit'">
                <span class="nums" v-if="editData.platformCode">{{editData.platformCode.slice(0, 6)}}</span>
              </template>
              <el-input size="small" v-model="formAdd.platformCode" placeholder="请输入站点编号" class="w250 el-input-62"></el-input>
              <span class="tips">8位数字</span>
            </el-form-item>
          </el-form>
        </div>
        <div v-if="['mergeArea'].includes(type)">
          <el-form ref="mergeArea" :rules="mergeAreaRules" :model="mergeArea" label-width="80px">
            <el-form-item label="区域名称" prop="areaName">
              <el-input size="small" v-model="mergeArea.areaName" placeholder="请输入区域名称" class="w250"></el-input>
            </el-form-item>
            <el-form-item label="区域代码" prop="id">
              <el-input size="small" v-model="mergeArea.id" placeholder="请输入区域代码" class="w250"></el-input>
              <span class="tips">6位数字</span>
            </el-form-item>
            <el-form-item label="站点编号" prop="platformCode">
              <el-input size="small" v-model="mergeArea.platformCode" placeholder="请输入站点编号" class="w250"></el-input>
              <span class="tips">8位数字</span>
            </el-form-item>
          </el-form>
        </div>
        <div v-if="['del'].includes(type)">
          <p>你是否确定移除“{{editData.areaName}}”？</p>
        </div>
        <div v-if="['setRail'].includes(type)">
          <p v-if="['painting'].includes(typeStyle)">你是否确定放弃本次区域围栏绘制？</p>
          <p v-if="['paintingEdit'].includes(typeStyle)">你是否确定放弃本次区域围栏编辑？</p>
          <p v-if="typeStyle === 'noEntryFence'">你是否确定放弃本次禁行区围栏绘制？</p>
        </div>
      </template>
    </w-dialog>
    <!-- 围栏绘制 -->
    <div v-if="showPainting" class="layout" style="margin-left: 0px;z-index: 11;">
      <div class="system-setting">
        <div id="paintContainer"></div>
        <div id="toolControl" class="map_handle_box_device" v-if="['paintingEdit', 'paintingEdit', 'delete'].includes(typeStyle)">
          <!-- <div class="toolItem" v-show="typeStyle === 'painting'" :class="{'active': drawType === 'draw'}" id="draw" @click="onEditor('draw')" title="折线"></div> -->
          <!-- <div class="toolItem" v-show="typeStyle === 'paintingEdit'" :class="{'active': drawType === 'delete'}" id="delete" @click="onEditor('delete')" title="编辑"></div> -->
          <!-- <div class="toolItem" :class="{'active': drawType === 'delete'}" id="delete" @click="onEditor('delete')" title="删除"></div> -->
          <!-- <div class="toolItem" :class="{'active': drawType === 'split'}" id="split" @click="onEditor('split')" title="拆分"></div> -->
          <!-- <div class="toolItem" v-show="typeStyle === 'paintingEdit'" :class="{'active': drawType === 'union'}" id="union" @click="onEditor('union')" title="合并"></div> -->
          <div class="title">修改围栏</div>
          <div class="map_handles">
              <div class="map_handle" @click="onEditor('delete')">删除图形</div>
              <div class="map_handle" @click="onEditor('union')">合并图形</div>
          </div>
        </div>
        <div class="fixed-bottom">
          <div class="flex-center">
            <el-button @click="onSavePaint" size="small" type="primary">保存</el-button>
            <el-button @click="onCancelPaintPre('setRail')" size="small">取消</el-button>
          </div>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
import Api from '@/api'
import WDialog from '@/components/Model/index.vue'
import { mapGetters } from 'vuex'
import store from '../../../store'

var AMap = window.AMap
export default {
  name: 'regional',
  data() {
    return {
      // baseApi: 'https://apis.map.qq.com/ws/district/v1/',
      // api: 'getchildren?id=330000&max_offset=3000&get_polygon=2',
      tableViewHeight: 0,
      dialogTitle: '',
      type: '',
      tableLoading: false,
      areaLists: [],
      tableData: [],
      // 添加区域
      formAdd: {
        level: '',
        areaName: '',
        id: '',
        platformCode: ''
      },
      sureBtnText: '',
      // 编辑区域
      editData: null,
      formAddRules: {
        level: [
          { required: true, message: '请选择等级', trigger: 'blur' }
        ],
        areaName: [
          { required: true, message: '请填写区域名称', trigger: 'blur' }
        ],
        id: [
          { required: true, message: '请填写区域代码', trigger: 'blur' },
          { min: 2, max: 2, message: '区域代码必须6位', trigger: 'blur' },
          { validator: this.validateId.bind(this), trigger: 'blur' }
        ],
        platformCode: [
          { required: true, message: '请填写站点编号', trigger: 'blur' },
          { min: 2, max: 2, message: '站点编号必须8位', trigger: 'blur' },
          { validator: this.validatePlatformCode.bind(this), trigger: 'blur' }
        ]
      },
      // 合并区域
      mergeArea: {
        areaName: '',
        id: '',
        platformCode: ''
      },
      mergeAreaRules: {
        areaName: [
          { required: true, message: '请填写区域名称', trigger: 'blur' }
        ],
        id: [
          { required: true, message: '请填写区域代码', trigger: 'blur' },
          { min: 6, max: 6, message: '区域代码必须6位', trigger: 'blur' }
        ],
        platformCode: [
          { required: true, message: '请填写站点编号', trigger: 'blur' },
          { min: 8, max: 8, message: '站点编号必须8位', trigger: 'blur' }
        ]
      },
      nationAddress: {},
      addressCascader: {
        value: 'id',
        label: 'areaName'
      },
      multipleSelection: [],
      originAreaData: [], // 只保存每次的原始数据
      // 围栏绘制相关
      showPainting: false,
      map: undefined,
      editor: undefined,
      qqKey: 'K3RBZ-P4JEB-DBJUO-NDWCL-ESZ7Q-QUB6U',
      actionMode: TMap.tools.constants.EDITOR_ACTION.DRAW,
      drawType: 'draw',
      activeOverlayId: 'draw',
      geometryList: [], // 绘制的图形列表集合
      geometries: [], // 绘制已绘制的图形
      editGeometriesId: null,
      typeStyle: null,
      geometriesSelectList: [], // 保存参与合并的图形的集合
      locationByAreaName: '',
      currItem: null
    }
  },
  computed: {
    ...mapGetters([
      'nationalArea',
      'user',
      'selfAreaId',
      'permissions',
      'globaleSelfAreaId',
      'userLevel']),
    apiDefaultParams() {
      return { selfAreaId: this.selfAreaId }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    onClickDel() {
      const vm = this
      const params = {
        ...vm.apiDefaultParams,
        id: 17
      }
      Api.delRail(params)
        .then(res => {
          if (res.code === 200) {
            vm.$message.success('区域围栏删除成功！')
          } else {
            vm.$message.warning(res.message)
          }
        })
        .catch(err => {
          console.log('删除区域围栏报错：', err)
        })
    },
    // 校验相关
    validateId(rule, value, callback) {
      if (this.type === 'formAdd' && (!this.formAdd.level || this.formAdd.level.length === 0)) {
        callback(new Error('请选择省份'))
      }
      console.log(this.formAdd.id, value)
      // callback(new Error('请输入合法的登录账号'))
      // todo api
      callback()
    },
    validatePlatformCode(rule, value, callback) {
      if (this.type === 'formAdd' && (!this.formAdd.level || this.formAdd.level.length === 0)) {
        callback(new Error('请选择省份'))
      }
      console.log(this.formAdd.platformCode, value)
      // callback(new Error('请输入合法的登录账号'))
      // todo api
      callback()
    },
    // 图形绘制相关
    async onSavePaint() {
      console.log(this.geometryList, this.editData, this.editGeometriesId)
      if (this.editGeometriesId) {
        // 编辑
        if (this.typeStyle === 'noEntryFence') {
          await this.editEntryRail()
        } else if (['paintingEdit', 'painting'].includes(this.typeStyle)) {
          await this.editRail()
        }
      } else {
        // 新增
        if (this.typeStyle === 'noEntryFence') {
          await this.setEntryRail()
        } else if (this.typeStyle === 'painting') {
          await this.setRail()
        }
      }
    },
    editEntryRail() {
      const vm = this
      return new Promise((resolve, reject) => {
        const params = {
          ...vm.apiDefaultParams,
          id: vm.editGeometriesId,
          gpsRail: (vm.geometryList && vm.geometryList.length) ? JSON.stringify(vm.geometryList) : JSON.stringify([])
        }
        Api.editEntryRail(params)
          .then(res => {
            if (res.code === 200) {
              vm.$message.success('禁行区围栏修改成功！')
              vm.onCancelPaint()
              resolve(res)
            } else {
              vm.$message.warning(res.message)
              reject(res)
            }
          })
          .catch(err => {
            console.log('修改禁行区围栏报错：', err)
            reject(err)
          })
      })
    },
    editRail() {
      const vm = this
      return new Promise((resolve, reject) => {
        const params = {
          ...vm.apiDefaultParams,
          id: vm.editGeometriesId,
          gpsRail: (vm.geometryList && vm.geometryList.length) ? JSON.stringify(vm.geometryList) : ''
        }
        Api.editRail(params)
          .then(res => {
            if (res.code === 200) {
              vm.$message.success('区域围栏修改成功！')
              vm.onCancelPaint()
              resolve(res)
            } else {
              vm.$message.warning(res.message)
              reject(res)
            }
          })
          .catch(err => {
            console.log('修改区域围栏报错：', err)
            reject(err)
          })
      })
    },
    setEntryRail() {
      const vm = this
      return new Promise((resolve, reject) => {
        const params = {
          ...vm.apiDefaultParams
        }
        const data = {
          areaId: vm.editData.id,
          selectAreaId: vm.editData.id,
          gpsRail: (vm.geometryList && vm.geometryList.length) ? JSON.stringify(vm.geometryList) : JSON.stringify([])
        }
        Api.setEntryRail(data, params)
          .then(res => {
            if (res.code === 200) {
              vm.$message.success('禁行区围栏绘制成功！')
              vm.onCancelPaint()
              resolve(res)
            } else {
              vm.$message.warning(res.message)
              reject(res)
            }
          })
          .catch(err => {
            console.log('创建禁行区围栏报错：', err)
            reject(err)
          })
      })
    },
    setRail() {
      const vm = this
      return new Promise((resolve, reject) => {
        const params = {
          ...vm.apiDefaultParams
        }
        const data = {
          areaId: vm.editData.id,
          selectAreaId: vm.editData.id,
          gpsRail: (vm.geometryList && vm.geometryList.length) ? JSON.stringify(vm.geometryList) : JSON.stringify([])
        }
        Api.setRail(data, params)
          .then(res => {
            if (res.code === 200) {
              vm.$message.success('区域围栏绘制成功！')
              vm.onCancelPaint()
              resolve(res)
            } else {
              vm.$message.warning(res.message)
              reject(res)
            }
          })
          .catch(err => {
            console.log('创建区域围栏报错：', err)
            reject(err)
          })
      })
    },
    onCancelPaintPre(type) {
      this.dialogTitle = '温馨提示'
      this.sureBtnText = '确定'
      this.type = type
      this.$refs['w-dialog'].onShowDialog()
    },
    onCancelPaint() {
      this.typeStyle = null
      this.editGeometriesId = null
      this.geometries = []
      this.geometryList = []
      this.editData = null
      this.drawType = 'draw'
      this.showPainting = false
      this.actionMode = TMap.tools.constants.EDITOR_ACTION.DRAW
      this.activeOverlayId = 'draw'
      this.onClose()
    },
    onEditor(type) {
      this.drawType = type
      if (['draw'].includes(type)) {
        this.actionMode = TMap.tools.constants.EDITOR_ACTION.DRAW
        this.editor.setActionMode(this.actionMode)
        this.editor.setActiveOverlay(type)
        this.activeOverlayId = 'draw'
      } else {
        this.actionMode = TMap.tools.constants.EDITOR_ACTION.INTERACT
        this.editor.setActionMode(this.actionMode)
        this.editor.setActiveOverlay('polygon')
        this.activeOverlayId = 'polygon'
        this.editor[type]()
      }
    },
    getRail(row) {
      const vm = this
      return new Promise((resolve, reject) => {
        const params = {
          ...vm.apiDefaultParams,
          areaId: row.id,
          selectAreaId: row.id
        }
        Api.getRail(params)
          .then(res => {
            if (res.code === 200) {
              resolve(res)
            } else {
              vm.$message.warning(res.message)
              reject(res)
            }
          })
          .catch(err => {
            console.log('获取区域围栏报错：', err)
            reject(err)
          })
      })
    },
    getEntryRail(row) {
      const vm = this
      return new Promise((resolve, reject) => {
        const params = {
          ...vm.apiDefaultParams,
          areaId: row.id,
          selectAreaId: row.id
        }
        Api.getEntryRail(params)
          .then(res => {
            if (res.code === 200) {
              resolve(res)
            } else {
              vm.$message.warning(res.message)
              reject(res)
            }
          })
          .catch(err => {
            console.log('获取区域围栏报错：', err)
            reject(err)
          })
      })
    },
    async onClick(row, type) {
      // console.log(row, type)
      const vm = this
      // await vm.getDistrictChildren(row)
      vm.typeStyle = type
      let res
      if (type === 'painting') {
        // 区域围栏 - 绘制
        if (vm.checkUserAuth(6, 109)) {
          res = await vm.getRail(row)
        }
        vm.actionMode = TMap.tools.constants.EDITOR_ACTION.DRAW
        vm.activeOverlayId = 'draw'
        vm.drawType = 'draw'
      } else if (type === 'paintingEdit') {
        // 区域围栏 - 编辑
        if (vm.checkUserAuth(6, 109)) {
          res = await vm.getRail(row)
        }
        vm.actionMode = TMap.tools.constants.EDITOR_ACTION.INTERACT
        vm.activeOverlayId = 'polygon'
        vm.drawType = 'delete'
      } else if (type === 'noEntryFence') {
        // 禁行区
        res = await vm.getEntryRail(row)
      }
      if (res && res.code && res.data && res.data.length) {
        vm.geometries = []
        vm.geometryList = []
        res.data.forEach(item => {
          if (item.gpsRally && JSON.parse(item.gpsRally) && JSON.parse(item.gpsRally)[0] && JSON.parse(item.gpsRally)[0].id) {
            vm.editGeometriesId = item.id
            const gpsRally = JSON.parse(item.gpsRally)
            gpsRally.forEach(pgs => {
              const length = pgs.paths && pgs.paths.length
              if (length) {
                const paths = []
                pgs.paths.forEach(path => {
                  paths.push(new TMap.LatLng(path.lat, path.lng))
                })
                vm.geometries.push({ paths })
                vm.geometryList.push(pgs)
              }
            })
          }
        })
        // vm.actionMode = TMap.tools.constants.EDITOR_ACTION.INTERACT
        // vm.activeOverlayId = 'polygon'
        // vm.drawType = 'delete'
      } else {
        console.log('当前地图没有围栏')
        // vm.actionMode = TMap.tools.constants.EDITOR_ACTION.DRAW
        // vm.activeOverlayId = 'draw'
        // vm.drawType = 'draw'
      }
      vm.editData = row
      vm.showPainting = true
      vm.locationByAreaName = await vm.getLocationByAreaName(row)
      vm.$nextTick(vm.initMap.bind(vm, vm.locationByAreaName))
    },
    initMap(location) {
      // console.log('initMap', location)
      const vm = this
      if (!location || !location.lng || !location.lat) {
        vm.$message.error('地址解析发生错误！')
        return
      }
      // 初始化地图
      if (vm.editor) {
        vm.editor = null
      }
      vm.map = new TMap.Map('paintContainer', {
        zoom: 12, // 设置地图缩放级别
        center: new TMap.LatLng(location.lat, location.lng) // 设置地图中心点坐标
      })
      // 初始化几何图形及编辑器
      vm.editor = new TMap.tools.GeometryEditor({
        map: vm.map, // 编辑器绑定的地图对象
        overlayList: [ // 可编辑图层
          {
            // GeometryEditor 以 MultiPolygon（可以理解为多边形图层）激活进行编辑
            id: 'draw',
            overlay: new TMap.MultiPolygon({
              map: vm.map,
              styles: {
                highlight: new TMap.PolygonStyle({
                  color: 'rgba(255, 255, 0, 0.6)'
                })
              }
            }),
            selectedStyleId: 'highlight'
          },
          {
            id: 'polygon',
            selectedStyleId: 'highlight',
            overlay: new TMap.MultiPolygon({
              map: vm.map,
              geometries: vm.geometries,
              styles: {
                highlight: new TMap.PolygonStyle({
                  color: 'rgba(255, 255, 0, 0.6)'
                })
              }
            })
          }
        ],
        activeOverlayId: vm.activeOverlayId, // 激活图层
        actionMode: vm.actionMode, // 编辑器的工作模式
        snappable: true, // 开启邻近吸附
        selectable: true // 开启点选功能
      })
      // 监听绘制结束事件，获取绘制几何图形
      vm.editor.on('draw_complete', (geometry) => {
        console.log('图形绘制完成', geometry)
        vm.geometryList.push(geometry)
        vm.geometries.push(geometry)
      })
      vm.editor.on('select', (geometry) => {
        vm.geometriesSelectList = vm.editor.getSelectedList()
      })
      // 监听删除、修改、拆分、合并完成事件
      const evtList = ['delete', 'adjust', 'split', 'union']
      evtList.forEach(evtName => {
        vm.editor.on(evtName + '_complete', evtResult => {
          if (evtName === 'adjust') {
            // 修改 - 替换
            let index
            vm.geometries.forEach((item, idx) => {
              if (item.id === evtResult.id) {
                index = idx
              }
            })
            console.log('edit', index)
            vm.geometryList.splice(index, 1, evtResult)
            vm.geometries.splice(index, 1, evtResult)
          } else if (evtName === 'delete') {
            // 删除 - 删除
            const curr = evtResult && evtResult[0]
            if (curr && curr.id) {
              let index
              vm.geometries.forEach((item, idx) => {
                if (item.id === evtResult.id) {
                  index = idx
                }
              })
              console.log('delete', index)
              vm.geometryList.splice(index, 1)
              vm.geometries.splice(index, 1)
            }
          } else if (evtName === 'union') {
            // 合并成功
            if (vm.geometriesSelectList && vm.geometriesSelectList.length) {
              // 删除参与合并的图形
              vm.geometriesSelectList.forEach(item => {
                vm.geometries.forEach((geo, index) => {
                  if (geo.id === item.id) {
                    vm.geometries.splice(index, 1)
                    vm.geometryList.splice(index, 1)
                  }
                })
              })
              // 新增合并后的新图形
              vm.geometryList.push(evtResult)
              vm.geometries.push(evtResult)
            }
            vm.geometriesSelectList = []
          }
          console.log('图片处理完成', vm.geometryList, vm.geometries)
        })
      })
      // 监听拆分失败事件，获取拆分失败原因
      vm.editor.on('split_fail', (res) => {
        console.log('split_fail', res.message)
      })
      // 监听合并失败事件，获取合并失败原因
      vm.editor.on('union_fail', (res) => {
        console.log('union_fail', res.message)
      })
    },
    // 事件处理区
    onSelectionChange(val) {
      console.log(val)
      this.multipleSelection = val
    },
    onRowClick(row, column, event) {
      // console.log(row, column, event)
      this.getArea(row)
    },
    onAdd(title, type) {
      const vm = this
      // 获取地址
      vm.nationAddress = vm.delAddressInLevel2(vm.nationalArea)
      vm.nationAddress = vm.listToTree(vm.nationAddress)
      vm.nationAddress = vm.changeAddress(vm.nationAddress)
      vm.dialogTitle = title
      vm.sureBtnText = '添加'
      vm.type = type
      vm.$refs['w-dialog'].onShowDialog()
    },
    onEdit(type, row) {
      const vm = this
      vm.editData = row
      vm.dialogTitle = '修改区域'
      vm.sureBtnText = '保存'
      vm.type = type
      vm.formAdd.id = row.id.slice(row.id.length - 2, row.id.length)
      vm.formAdd.areaName = row.areaName
      vm.formAdd.platformCode = row.platformCode.slice(row.platformCode.length - 2, row.platformCode.length)
      vm.$refs['w-dialog'].onShowDialog()
    },
    onDel(type, row) {
      const vm = this
      vm.editData = row
      vm.dialogTitle = '温馨提示'
      vm.sureBtnText = '确定'
      vm.type = type
      vm.$refs['w-dialog'].onShowDialog()
    },
    onMerge(title, type) {
      if (!this.multipleSelection.length) {
        this.$message.warning('请选择需要合并的区域！')
        return
      }
      const parentId = this.multipleSelection[0].parentId
      const isAgree = this.multipleSelection.every(item => item.parentId === parentId)
      if (!isAgree) {
        this.$message.warning('当前所选区域不可合并，请重新选择！')
        return
      }
      this.dialogTitle = title
      this.sureBtnText = '合并'
      this.type = type
      this.$refs['w-dialog'].onShowDialog()
    },
    getLocationByAreaName(row) {
      const parent = this.areaLists.filter(item => item.id === row.parentId)
      // console.log(222, parent)
      let areaName = row.areaName
      if (parent && parent.length && parent[0]) {
        areaName = parent[0].areaName + areaName
      }
      return new Promise((resolve, reject) => {
        AMap.plugin('AMap.Geocoder', function() {
          var geocoder = new AMap.Geocoder()
          geocoder.getLocation(areaName, function(status, result) {
            if (status === 'complete' && result.info === 'OK') {
              // 经纬度
              var lng = result.geocodes[0].location.lng
              var lat = result.geocodes[0].location.lat
              resolve({ lng, lat })
            } else {
              console.log('定位失败！')
              reject(new Error('getLocationByAreaName: 定位失败！'))
            }
          })
        })
      })
    },
    getDistrictChildren(row) {
      const vm = this
      return new Promise((resolve, reject) => {
        const params = {
          id: row.id, // 父级行政区划ID（adcode）
          max_offset: row.level >= 2 ? '500' : '3000',
          key: vm.qqKey
        }
        Api.getDistrictChildren(params)
          .then(res => {
            console.log(res)
            resolve(res)
          })
          .catch(err => {
            console.log('腾讯地图获取行政区划api报错：', err)
            reject(err)
          })
      })
    },
    onCommand(type, row) {
      if (type === 'edit') {
        this.onEdit(type, row)
      } else if (type === 'del') {
        this.onDel(type, row)
      } else if (type === 'noEntryFence') {
        this.onClick(row, type)
      } else if (type === 'paintingEdit') {
        this.onClick(row, type)
      } else {
        console.log('onCommand')
      }
    },
    setMonitorOpenByRecursion(row, list = []) {
      if (!row || (row && !row.id)) {
        return null
      }
      if (list && !list.length) {
        return null
      }
      for (let i = 0, l = list.length; i < l; i++) {
        const item = list[i]
        if (item.id && item.id === row.id) {
          item.monitorOpen = row.monitorOpen ? 1 : 0
          item.isOpen = row.isOpen ? 1 : 0
          return null
        } else if (item.child && item.child.length) {
          this.setMonitorOpenByRecursion(row, item.child)
        }
      }
    },
    fetchEditArea(data) {
      // 获取初始化地址
      const vm = this
      vm.tableLoading = true
      return new Promise((resolve, reject) => {
        Api.editArea(data, vm.apiDefaultParams)
          .then(res => {
            if (res.code === 200) {
              vm.$message.success('操作成功！')
              resolve(res)
            } else {
              vm.$message.warning(res.message)
              reject(res)
            }
            vm.tableLoading = false
          })
          .catch(err => {
            vm.tableLoading = false
            reject(err)
            console.log(err)
          })
      })
    },
    // 显示功能
    getListAddress(row, arrs) {
      arrs.push(row)
      if (row.aggregation === 0 && row.aggregationId) {
        // 复合区
        const aggregation = this.areaLists.find(item => item.id === row.aggregationId)
        return this.getListAddress(aggregation, arrs)
      } else if (row.parentId) {
        const parent = this.areaLists.find(item => item.id === row.parentId)
        return this.getListAddress(parent, arrs)
      } else {
        return arrs
      }
    },
    checkParent(row) {
      const list = this.getListAddress(row, [])
      let res = true
      for (let i = 1, l = list.length; i < l; i++) {
        const item = list[i]
        if (!item.monitorOpen) {
          res = false
          break
        }
      }
      return res
    },
    checkParentMi(row) {
      const list = this.getListAddress(row, [])
      let res = true
      for (let i = 1, l = list.length; i < l; i++) {
        const item = list[i]
        if (!item.isOpen) {
          res = false
          break
        }
      }
      return res
    },
    checkAllChildren(originCurr, arr) {
      if (originCurr.child) {
        for (let i = 0, l = originCurr.child.length; i < l; i++) {
          const item = originCurr.child[i]
          arr.push(item.areaName)
          if (item.child) {
            return this.checkAllChildren(item, arr)
          }
        }
      } else {
        arr.push(originCurr.areaName)
      }
      return arr
    },
    checkChild(row) {
      let res = true
      if (row.child) {
        res = row.child.every(item => !item.monitorOpen)
      }
      return res
    },
    checkChildMi(row) {
      let res = true
      if (row.child) {
        res = row.child.every(item => !item.isOpen)
      }
      return res
    },
    // 监管平台是否显示
    async onSwitchChange(row) {
      console.log(row)
      const vm = this
      // vm.setMonitorOpenByRecursion(row, vm.originAreaData)
      // console.log(vm.originAreaData)
      if (Number(vm.user.areaLevel) >= row.level && vm.user.areaId !== row.id && vm.user.areaId !== '000000') {
        vm.$message.error('权限不足，无法关闭')
        row.monitorOpen = !row.monitorOpen
        return
      }
      // 检查上级s
      if (!this.checkParent(row)) {
        vm.$message.error('请先开通上一级地区')
        row.monitorOpen = !row.monitorOpen
        return
      }
      // 检查下级s
      if (!row.monitorOpen && row.child && !this.checkChild(row)) {
        vm.$message.error('请先关闭下一级地区')
        row.monitorOpen = !row.monitorOpen
        return
      }
      const data = JSON.parse(JSON.stringify(row))
      data.monitorOpen = data.monitorOpen ? 1 : 0
      if (data.monitorOpen === 0) {
        data.isOpen = 0
        row.isOpen = false
      } else {
        data.isOpen = data.isOpen ? 1 : 0
      }
      await vm.fetchEditArea(data)
      // 不刷新
      // vm.init()
      vm.refreshAddress()
    },
    // 觅单车是否显示
    async onSwitchChangeMi(row) {
      console.log('onSwitchChangeMi', row)
      const vm = this
      // vm.setMonitorOpenByRecursion(row, vm.originAreaData)
      // console.log(vm.originAreaData)
      if (Number(vm.user.areaLevel) >= row.level && vm.user.areaId !== row.id && vm.user.areaId !== '000000') {
        vm.$message.error('权限不足，无法关闭')
        row.isOpen = !row.isOpen
        return
      }
      if (!this.checkParentMi(row)) {
        vm.$message.error('请先开通上一级地区')
        row.isOpen = !row.isOpen
        return
      }
      // 检查下级s
      if (!row.isOpen && row.child && !this.checkChildMi(row)) {
        vm.$message.error('请先关闭下一级地区')
        row.isOpen = !row.isOpen
        return
      }
      const data = JSON.parse(JSON.stringify(row))
      data.isOpen = data.isOpen ? 1 : 0
      data.monitorOpen = data.monitorOpen ? 1 : 0
      console.log(data, 223333)
      await vm.fetchEditArea(data)
      // 不刷新
      // vm.init()
      vm.refreshAddress()
    },
    onAddressChange(value) {
      console.log(value)
      if (value && value.length) {
        this.currItem = this.nationalArea.find(item => item.id === value[value.length - 1])
      }
    },
    // 弹窗处理
    onRightClose() {
      this.onClose()
    },
    onClose() {
      this.$refs['w-dialog'].onCloseDialog()
      this.clearFormDate()
    },
    clearFormDate() {
      if (['formAdd', 'edit'].includes(this.type)) {
        this.formAdd.level = ''
        this.formAdd.areaName = ''
        this.formAdd.id = ''
        this.formAdd.platformCode = ''
      } else if (this.type === 'mergeArea') {
        this.mergeArea.areaName = ''
        this.mergeArea.id = ''
        this.mergeArea.platformCode = ''
      } else if (this.type === 'setRail') {
        return null
      }
      this.currItem = null
      this.editData = null
      this.dialogTitle = ''
      this.sureBtnText = ''
      this.type = ''
    },
    onSure() {
      if (this.type === 'formAdd') {
        // 添加区域
        this.handleAdd()
      } else if (this.type === 'edit') {
        // 编辑区域
        this.handleEdit()
      } else if (this.type === 'del') {
        // 删除
        this.handleDel()
      } else if (this.type === 'mergeArea') {
        // 合并区域
        this.handleMergeArea()
      } else if (this.type === 'setRail') {
        this.onCancelPaint()
      }
    },
    // 数据处理
    findByOwn(data, map, mapkey) {
      // 深度检索当前地址对应的 地区
      // 返回检索到的目标地址
      // console.log(data, map, mapkey)
      for (let i = 0, l = data.length; i < l; i++) {
        const item = data[i]
        if (item.id === mapkey) {
          return item
        } else if (item.child && item.child.length) {
          const current = this.findByOwn(item.child, map, mapkey)
          if (current) {
            return current
          }
        }
      }
    },
    translateTableData(data, map, mapkey) {
      // 依赖 findByOwn
      // 收集当前table全量地址，转化这些数据到可以展示到table中
      // 返回tableData
      let temp
      if ((!data || data.length === 0) && (!map || map.length === 0)) {
        temp = []
      } else if (data && data.length && map && map.length && mapkey) {
        const current = this.findByOwn(data, map, mapkey)
        current.child = []
        current.child = map
        temp = data
      } else if (data && data.length) {
        temp = data
      } else {
        temp = map
      }
      if (!map && !mapkey) {
        // 初始化的时候整理数据
        temp.forEach(item => {
          item.monitorOpen = !!item.monitorOpen
          item.isOpen = !!item.isOpen
          if (item.child) {
            item.child = []
          }
          if (item.child && item.child.length) {
            return this.translateTableData(item.child)
          }
        })
      }
      return temp
    },
    filterAddress(list, address) {
      // 返回当前 区域下面的 子集
      if (!list || list.length === 0) {
        return []
      }
      // tableData 的逻辑
      if (!address || !address.id) {
        if (this.selfAreaId === '000000') {
          return list.filter(item => item.level === 0)
        } else {
          return list.filter(item => (item.level === 0 && (this.selfAreaId.slice(0, 2) + '0000') === item.id))
        }
      }
      const newLists = list.filter(item => {
        if (item.aggregation === 0 && item.aggregationId) {
          // 处理复合区
          return item.aggregationId === address.id
        } else {
          // 普通实体区
          return item.parentId === address.id
        }
      })
      return newLists
    },
    init() {
      // 获取初始化地址
      const vm = this
      vm.tableLoading = true
      return new Promise((resolve, reject) => {
        Api.regionalArea(vm.apiDefaultParams)
          .then(res => {
            if (res.code === 200) {
              // if (vm.selfAreaId === '000000') {
              //   vm.originAreaData = JSON.parse(JSON.stringify(res.data))
              // } else {
              //   vm.originAreaData = JSON.parse(JSON.stringify(res.data)).filter(item => item.id === (vm.selfAreaId.slice(0, 2) + '0000'))
              // }
              vm.originAreaData = res.data
              vm.areaLists = vm.translateTableData(vm.treeToList(res.data))
              vm.tableData = vm.filterAddress(vm.areaLists, '')
            } else {
              vm.$message.warning(res.message)
            }
            vm.calcView()
            vm.tableLoading = false
          })
          .catch(err => {
            vm.tableLoading = false
            console.log(err)
          })
      })
    },
    getArea(address) {
      // 获取当前点击的地址集合
      const vm = this
      vm.tableLoading = true
      let list = vm.filterAddress(vm.areaLists, address)
      const hasCity = list.some(item => item.id === (vm.selfAreaId.slice(0, 4) + '00'))
      const hasArea = list.some(item => item.id === vm.selfAreaId)
      if (hasCity) {
        list = list.filter(item => item.id === (vm.selfAreaId.slice(0, 4) + '00'))
      }
      if (hasArea) {
        list = list.filter(item => item.id === vm.selfAreaId)
      }
      console.log('list', list)
      vm.tableData = vm.translateTableData(vm.tableData, list, address.id)
      vm.tableLoading = false
    },
    check(type) {
      const vm = this
      return new Promise((resolve, reject) => {
        vm.$refs[type].validate((valid) => {
          if (valid) {
            resolve()
          } else {
            console.log('error submit!!')
            return false
          }
        })
      })
    },
    refreshAddress() {
      const vm = this
      const params = {
        selfAreaId: vm.globaleSelfAreaId,
        userAreaId: vm.globaleSelfAreaId
      }
      // 用户区域范围拉取
      params.areaId = vm.globaleSelfAreaId
      store.dispatch('user/getUserArea2', params).then(() => {
        store.dispatch('user/setSideBarLoading', {
          value: false
        }).then(() => vm.noon)
      })
    },
    noon() {},
    // 添加区域 - 默认开放
    async handleAdd() {
      const vm = this
      await vm.check('formAdd')
      if (!vm.currItem || (vm.currItem && !vm.currItem.platformCode)) {
        vm.$message.warning('数据有误！')
        return
      }
      const data = {
        ...vm.formAdd,
        id: vm.formAdd.level[vm.formAdd.level.length - 1].slice(0, 4) + vm.formAdd.id,
        platformCode: vm.currItem.platformCode.slice(0, 6) + vm.formAdd.platformCode,
        level: 2, // 省=0,市=1,区=2,复合区=2
        parentId: vm.formAdd.level[vm.formAdd.level.length - 1],
        monitorOpen: 1, // 默认开放
        isOpen: 1,
        aggregation: 0 // 没有复合区的概念了
      }
      Api.addRegionalArea(data, vm.apiDefaultParams)
        .then(res => {
          if (res.code === 200) {
            vm.$message.success('区域添加成功！')
            vm.onClose()
            vm.init()
            vm.refreshAddress()
          } else {
            vm.$message.warning(res.message)
          }
        })
        .catch(err => {
          console.log('addRegionalArea', err)
        })
    },
    // 编辑区域 - 不改变是否开放
    async handleEdit () {
      const vm = this
      await vm.check('formAdd')
      const data = {
        ...vm.editData,
        id: vm.editData.id.slice(0, 4) + vm.formAdd.id,
        platformCode: vm.editData.platformCode.slice(0, 6) + vm.formAdd.platformCode,
        areaName: vm.formAdd.areaName,
        monitorOpen: vm.editData.monitorOpen ? 1 : 0,
        isOpen: vm.editData.isOpen ? 1 : 0
      }
      Api.editRegionalArea(data, vm.apiDefaultParams)
        .then(res => {
          if (res.code === 200) {
            vm.$message.success('区域修改保存成功！')
            vm.onClose()
            vm.init()
            vm.refreshAddress()
          } else {
            vm.$message.warning(res.message)
          }
        })
        .catch(err => {
          console.log('handleEdit', err)
        })
    },
    // 删除区域
    async handleDel() {
      const vm = this
      const data = {
        id: vm.editData.id
      }
      Api.deleteArea(data, vm.apiDefaultParams)
        .then(res => {
          if (res.code === 200) {
            vm.$message.success('区域移除成功！')
            vm.onClose()
            vm.init()
            vm.refreshAddress()
          } else {
            vm.$message.warning(res.message)
          }
        })
        .catch(err => {
          console.log('deleteArea', err)
        })
    },
    // 合并区域 - 默认开放
    async handleMergeArea() {
      const vm = this
      await vm.check('mergeArea')
      console.log(vm.multipleSelection)
      const data = {
        ...vm.mergeArea,
        level: 2, // 省=0,市=1,区=2,复合区=2
        parentId: vm.multipleSelection[0].parentId,
        monitorOpen: 1, // 默认开放
        isOpen: 1,
        aggregation: 1, // 没有复合区的概念了
        aggregationId: vm.multipleSelection.map(item => item.id).join(',')
      }
      Api.addRegionalArea(data, vm.apiDefaultParams)
        .then(res => {
          if (res.code === 200) {
            vm.$message.success('复合区合并成功！')
            vm.onClose()
            vm.init()
            vm.refreshAddress()
          } else {
            vm.$message.warning(res.message)
          }
        })
        .catch(err => {
          console.log('handleMergeArea', err)
        })
    },
    delAddressInLevel2(list) {
      return list.filter(node => node.level !== 2)
    },
    listToTree(list) {
      const info = list.reduce(
        (map, node) => {
          map[node.id] = node
          node.children = []
          return map
        }, {}
      )
      return list.filter(node => {
        info[node.parentId] && info[node.parentId].children.push(node)
        return !node.parentId
      })
    },
    treeToList(tree, result = []) {
      tree.forEach(node => {
        result.push(node)
        node.child && this.treeToList(node.child, result)
      })
      return result
    },
    changeAddress(list) {
      for (let i = 0, l = list.length; i < l; i++) {
        const item = list[i]
        if (item.children && item.children.length === 0) {
          delete item.children
        } else {
          this.changeAddress(item.children)
        }
      }
      return list
    },
    // 其他处理
    // 计划视图区域
    calcView() {
      this.$nextTick(() => {
        let H = 0
        if (this.$refs.searchBox && this.$refs.searchBox.clientHeight) {
          H += Number(this.$refs.searchBox.clientHeight)
        }
        // console.log('H', H)
        // 56: 导航栏高度修正
        // 79: table分页器高度修正
        this.tableViewHeight = window.innerHeight - H - 56 - 90
      })
    },
    // 对表格的默认操作
    cellClass(row) {
      if (row.columnIndex === 0) {
        return 'DisableSelection'
      }
    },
    selectable(row) {
      return row.aggregation === 0 && !row.aggregationId && row.level >= 2
    },
    // filter
    getLevel(l) {
      return {
        0: '省份',
        1: '地级市',
        2: '区、县、复合区',
        3: '区、县、复合区',
        4: '区、县、复合区',
        5: '区、县、复合区',
        6: '区、县、复合区'
      }[String(l)]
    }
  },
  components: {
    WDialog
  }
}
</script>

<style lang="less" scoped>
.layout-header.regional-header {
  box-sizing: border-box;
  margin: 24px 16px;
  margin-top: 0;
}
.regional {
  .el-button-box .el-button+.el-button {
    margin-left: 0;
  }
  .regional_table {
    padding: 16px;
    box-sizing: border-box;
  }
  .btn-text {
    font-size: 14px;
    font-weight: 400;
  }
  .mr12 {
    margin-right: 12px;
  }

  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
  .el-table .DisableSelection .cell .el-checkbox__inner{
    display: none;
    position: relative;
  }
  .el-table .DisableSelection .cell:before{
    content: "";
    position: absolute;
    // right: 11px;
  }
  .cell {
    cursor: pointer;
  }
  // .el-form-item {
  //   margin-bottom: 0;
  // }
  .w250 {
    width: 250px;
  }
  .tips {
    margin-left: 7px;
    color: #BBB;
    font-size: 14px;
  }
  .right {
    margin-right: 35px;
    text-align: right;
  }
  .fixed-bottom {
    width: 100%;
    height: 48px;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 1001;
    background-color: #FFF;
  }
  .flex-center {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  #toolControl {
    // position: absolute;
    // top: 10px;
    // left: 0px;
    // right: 0px;
    margin: auto;
    // width: 168px;
    z-index: 1001;
  }
  .toolItem {
    width: 30px;
    height: 30px;
    float: left;
    margin: 1px;
    padding: 4px;
    border-radius: 3px;
    background-size: 30px 30px;
    background-position: 4px 4px;
    background-repeat: no-repeat;
    box-shadow: 0 1px 2px 0 #E4E7EF;
    background-color: #ffffff;
    border: 1px solid #ffffff;
  }
  .toolItem:hover {
    border-color: #789CFF;
  }
  .active {
    border-color: #D5DFF2;
    background-color: #D5DFF2;
  }
  // 区域样式升级
  .nums {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 15px;
    color: #999;
    display: inline-block;
    font-size: 14px;
  }
  .el-input-45 input {
    padding-left: 45px;
    font-size: 14px;
  }
  .el-input-62 input {
    padding-left: 62px;
    font-size: 14px;
  }

  // 图例图标
  // #draw {
  //   background-image: url('https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/polyline.png');
  // }
  #draw {
    background-image: url('https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/polygon.png');
  }
  #delete {
    background-image: url('https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/delete.png');
  }
  #split {
    background-image: url('https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/split.png');
  }
  #union {
    background-image: url('https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/union.png');
  }

  .map_handle_box_device {
    position: absolute;
    border-radius: 5px;
    right: 31px;
    bottom: 88px;
    width: 124px;
    height: 118px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    background: #fff;
    box-sizing: border-box;
    padding: 10px;

    .map_handles {
        margin-top: 10px;

        .map_handle {
            cursor: pointer;
            border-radius: 12px;
            border: 1px solid #1F8FFB;
            color: #1F8FFB;
            padding: 2px 5px;
            text-align: center;
            margin-bottom: 10px;
        }
    }
  }

}
</style>
